import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_CHAT_FEEDBACK_API } from '../../constants/central-api';

export default async function tara_chat_feedback_api_call(
  responseId: string,
  feedbackReaction: boolean | null,
  feedbackComment?: string | null
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;
  const shop_slug = store.getState().user.company.shop_slug;

  const body: any = {
    response_id: responseId,
  };

  if (feedbackReaction !== null) {
    body.feedback_reaction = feedbackReaction;
  }

  if (feedbackComment && feedbackComment.trim() !== '') {
    body.feedback_comment = feedbackComment.trim();
  }

  const requestInfo: RequestInfo = {
    url: TARA_CHAT_FEEDBACK_API(shop_slug),
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'TARA_CHAT_FEEDBACK';
  const customMsg = 'Feedback submitted successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  if (res && res.aborted) {
    return res;
  }

  const response = res?.data;
  if (!response?.success) {
    return false;
  }

  if (res.actionType === actionType && response.success === true) {
    return response.data || null;
  }

  return false;
}
